import { __makeTemplateObject } from "tslib";
import { ThemeSelectors } from '@at/design-system-foundation';
import styled from 'styled-components';
export var ShowroomLiteGrid = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: grid;\n    gap: ", ";\n    grid-template-columns: ", ";\n    margin: ", ";\n    width: 100%;\n\n    > * {\n        place-self: center center;\n        width: 100%;\n    }\n"], ["\n    display: grid;\n    gap: ", ";\n    grid-template-columns: ", ";\n    margin: ", ";\n    width: 100%;\n\n    > * {\n        place-self: center center;\n        width: 100%;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
}, function (_a) {
    var _b, _c;
    var $gridCardSizes = _a.$gridCardSizes;
    return "repeat(auto-fit, minmax(".concat((_b = $gridCardSizes === null || $gridCardSizes === void 0 ? void 0 : $gridCardSizes.min) !== null && _b !== void 0 ? _b : '250px', ", ").concat((_c = $gridCardSizes === null || $gridCardSizes === void 0 ? void 0 : $gridCardSizes.max) !== null && _c !== void 0 ? _c : '1fr', "))");
}, function (_a) {
    var theme = _a.theme;
    return "".concat(ThemeSelectors.getGroupFourSpacing(theme), " 0 ").concat(ThemeSelectors.getGroupFiveSpacing(theme));
});
var templateObject_1;
